var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMagazineView = function SvgIconMagazineView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 93 82",
    id: "vector",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M 5 0 L 88 0 C 89.326 0 90.598 0.527 91.536 1.464 C 92.473 2.402 93 3.674 93 5 L 93 57 C 93 58.326 92.473 59.598 91.536 60.536 C 90.598 61.473 89.326 62 88 62 L 5 62 C 3.674 62 2.402 61.473 1.464 60.536 C 0.527 59.598 0 58.326 0 57 L 0 5 C 0 3.674 0.527 2.402 1.464 1.464 C 2.402 0.527 3.674 0 5 0 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M 5 68 L 53 68 C 54.326 68 55.598 68.527 56.536 69.464 C 57.473 70.402 58 71.674 58 73 L 58 77 C 58 78.326 57.473 79.598 56.536 80.536 C 55.598 81.473 54.326 82 53 82 L 5 82 C 3.674 82 2.402 81.473 1.464 80.536 C 0.527 79.598 0 78.326 0 77 L 0 73 C 0 71.674 0.527 70.402 1.464 69.464 C 2.402 68.527 3.674 68 5 68 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMagazineView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_magazine_view.3b56bde6.svg";
export { ForwardRef as ReactComponent };